import React, { useState } from "react";
import {
  Briefcase,
  Calendar,
  FilePlus,
  FileText,
  Folder,
  Home,
  Mail,
  Map,
  MessageSquare,
  Power,
  Settings,
  User,
  XOctagon,
  ArrowLeft,
  ArrowRight
} from "react-feather";
import { Link } from "react-router-dom";
import { useAuthState } from "../Helper/Context/context";



export default function Siderbar({ isopen, toggle, active }) {
  // const [toggleactive, settoggleactive] = useState("dashboard")

  const userDetails = useAuthState();
  const { RoleID } = userDetails

  // console.log('RoleID', RoleID)
  return (
    <div

      className={
        isopen
          ? "left-slidebar dark-shadow sidebar-block"
          : "left-slidebar dark-shadow sidebar-none"
      }
      style={{ width: isopen ? "100px" : "220px" }}
    >
      <div className="navbar-brand-wrapper d-flex align-items-center justify-content-center">
        {
          isopen ?
            <span className="navbar-brand brand-logo ey-small-logo">
              <img
                style={{ width: isopen ? "80px" : "", height: '30px' }}
                src="static/assets/img/dashboard/ey-png-4.png"
                className="logo "

                alt="short-logo"
              />

            </span>
            :
            <span className="navbar-brand brand-logo ey-logo">
              <img
                style={{ width: isopen ? "90%" : "" }}
                src="static/assets/img/dashboard/ey-png-4.png"
                className="logo"
                alt="logo"
              />
            </span>
        }

      </div>

      <nav
        className="sidebar  sidebar-offcanvas"
        id="sidebar"
        style={{ maxHeight: isopen ? "calc(100vh - 150px)" : " " }}
      >


        <ul className="nav d-block" >

          {
            RoleID == 6 &&

            <li
              className={active === "PlantationDashboard" ? " nav-item active" : "nav-item"}
            >
              <Link to="/PlantationDashboard" className="nav-link ">
                <i className={active === "PlantationDashboard" ? "menu-icon active1 " : "menu-icon"}>
                  {/* <img src="./assets/img/home.png" style={{ width: "21px" }} /> */}
                  <i class="fa-solid fa-home "></i>
                </i>
                <span
                  className="menu-title"
                  style={{ display: isopen ? "none" : "" }}
                >
                  Dashboard
                </span>
              </Link>
            </li>

          }


          {
            RoleID == 1 &&

            <>

              <li
                className={active === "Dashboard" ? " nav-item active" : "nav-item"}
              >
                <Link to="/Dashboard" className="nav-link ">
                  <i className={active === "Dashboard" ? "menu-icon active1 " : "menu-icon"}>
                    {/* <img src="./assets/img/home.png" style={{ width: "21px" }} /> */}
                    <i class="fa-solid fa-home "></i>
                  </i>
                  <span
                    className="menu-title"
                    style={{ display: isopen ? "none" : "" }}
                  >
                    Dashboard
                  </span>
                </Link>
              </li>
            </>
          }


          {

            RoleID == 5 &&
            <>
              <li
                className={active === "AdminDashboard" ? " nav-item active" : "nav-item"}
              >
                <Link to="/AdminDashboard" className="nav-link ">
                  <i className={active === "AdminDashboard" ? "menu-icon active1 " : "menu-icon"}>
                    {/* <img src="./assets/img/home.png" style={{ width: "21px" }} /> */}
                    <i class="fa-solid fa-home "></i>
                  </i>
                  <span
                    className="menu-title"
                    style={{ display: isopen ? "none" : "" }}
                  >
                    Beneficiary Data
                  </span>
                </Link>
              </li>
            </>


          }

          {

          }



          {
            RoleID == 1 ?
              <>
                <li className="li_hover">
                  <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false"
                    className="">
                    {/* <i className="icon-grid menu-icon icn"><User size={18} style={{ marginRight: '20px' }} /></i> */}
                    <div className="iconblock" style={{ display: 'flex', paddingLeft: '20px' }}>
                      <div className="innerblock pe-3">
                        <i class="fa-solid fa-tablet-screen-button text-white"></i>
                      </div>
                      <p className="text-white menu-title ps-1" style={{ display: isopen ? "none" : "" }}>Master Module</p>
                      <i class="fa-solid fa-caret-down text-white ps-2 pt-1" style={{ fontSize: '10px', display: isopen ? "none" : "" }}></i>
                    </div>
                  </a>
                  <ul className="" id='pageSubmenu'>
                    <>
                      <li
                        className={
                          active === "department_master" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/department-master" className="nav-link ">
                          <i className={active === "department_master" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-building "></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Department Master
                          </span>
                        </Link>

                      </li>

                      <li
                        className={
                          active === "designation_master" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/designation-master" className="nav-link ">
                          <i className={active === "designation_master" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-regular fa-clipboard"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Designation Master
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "define_employee" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/define-employee" className="nav-link ">
                          <i className={active === "define_employee" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-users"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Department Wise Employee
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "user_creation" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/user-creation" className="nav-link ">
                          <i className={active === "user_creation" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-user"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            User Creation/ User Transfer
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "define_project" ? " nav-item active " : "nav-item"
                        }
                      >
                        <Link to="/define-project" className="nav-link ">
                          <i className={active === "define_project" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-bars-progress"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Define Project
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "Implementingagencydetails" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/Implementingagencydetails" className="nav-link ">
                          <i className={active === "Implementingagencydetails" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-circle-info"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Implementing Agency Details
                          </span>
                        </Link>
                      </li>

                      <li
                        className={
                          active === "FieldStationwiseDistrictMaster" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/FieldStationwiseDistrictMaster" className="nav-link ">
                          <i className={active === "FieldStationwiseDistrictMaster" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-brands fa-playstation"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Field Station Wise District Master
                          </span>
                        </Link>
                      </li>

                      <li
                        className={
                          active === "District" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/District" className="nav-link ">
                          <i className={active === "District" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-building "></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            District Master
                          </span>
                        </Link>
                      </li>




                      <li
                        className={
                          active === "Taluka" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/Taluka" className="nav-link ">
                          <i className={active === "Taluka" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-building "></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Block Master
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "define_state_wise_project_area"
                            ? " nav-item active"
                            : "nav-item"
                        }
                      >
                        <Link to="/define-state-wise-project-area" className="nav-link ">
                          <i className={active === "define_state_wise_project_area" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-clone"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Define Project wise state area
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "projectwisesurveyor" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link
                          to="/projectwisesurveyor"
                          className="nav-link"
                        >

                          <i className={active === "projectwisesurveyor" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-map"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Project Wise Surveyor
                          </span>

                        </Link>
                      </li>

                      <li
                        className={
                          active === "beneficiaryMaster" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link
                          to="/beneficiaryMaster"
                          className="nav-link"
                        >

                          <i className={active === "beneficiaryMaster" ? "menu-icon active1 " : "menu-icon"}>
                            <i class="fa-solid fa-map"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Beneficiary Master
                          </span>

                        </Link>
                      </li>




                      {/* <li
                  className={
                    active === "district_taluka_wise_surveyor_mapping" ? " nav-item active" : "nav-item"
                  }
                >
                  <Link
                    to="/district-taluka-wise-surveyor-mapping"
                    className="nav-link"
                  >

                    <i className="menu-icon">
                      <i class="fa-solid fa-map"></i>
                    </i>
                    <span
                      className="menu-title"
                      style={{ display: isopen ? "none" : "" }}
                    >
                      District/ Taluka wise Surveyor Mapping
                    </span>

                  </Link>
                </li> */}
                    </>
                  </ul>
                </li>
                <li className="li_hover">
                  <a href="#pageSubmenu1" data-toggle="collapse" aria-expanded="false"
                    className="">
                    {/* <i className="icon-grid menu-icon icn"><User size={18} style={{ marginRight: '20px' }} /></i> */}
                    <div className="iconblock" style={{ display: 'flex', paddingLeft: '20px' }}>
                      <div className="innerblock pe-3 ">
                        <i class="fa-solid fa-arrow-up-from-bracket text-white"></i>
                      </div>
                      <p className="text-white" style={{ display: isopen ? "none" : "" }}> Upload Data</p>
                      <i class="fa-solid fa-caret-down text-white ps-2 pt-1" style={{ fontSize: '10px', display: isopen ? "none" : "" }}></i>
                    </div>
                  </a>
                  <ul className="" id='pageSubmenu1'>
                    <>

                      <li
                        className={
                          active === "define_project" ? " nav-item active " : "nav-item"
                        }
                      >
                        <Link to="/define-project" className="nav-link ">
                          <i className="menu-icon">
                            <i class="fa-brands fa-get-pocket"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Beneficiary Details
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "define_state_wise_project_area"
                            ? " nav-item active"
                            : "nav-item"
                        }
                      >
                        <Link to="/define-state-wise-project-area" className="nav-link ">
                          <i className="menu-icon">
                            <i class="fa-solid fa-tablet-screen-button "></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Nursery Master
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          active === "department_master" ? " nav-item active" : "nav-item"
                        }
                      >
                        <Link to="/department-master" className="nav-link ">
                          <i className="menu-icon">
                            <i class="fa-solid fa-sun-plant-wilt"></i>
                          </i>
                          <span
                            className="menu-title"
                            style={{ display: isopen ? "none" : "" }}
                          >
                            Nursery Details
                          </span>
                        </Link>
                      </li>

                    </>
                  </ul>
                </li>
              </>
              :
              ''
          }




        </ul>
      </nav>
    </div>
  );
}
